import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';

/**
 * @public
 */
export type SelectFilterProps = StylingProps &
  DataTestId &
  BehaviorTrackingProps & {
    /**
     * Flag indicating if the client-side filtering should be disabled or not.
     * @defaultValue false
     **/
    disableFiltering?: boolean;
    /** Defines the default filter string. */
    defaultValue?: string;
    /** Defines the filter string value. */
    value?: string;
    /** The callback is triggered when the filterValue changes. */
    onChange?: (filterValue: string) => void;
  };

/**
 * @public
 */
export function SelectFilter(props: SelectFilterProps): null {
  return null;
}
